import { useTypedSelector } from "@/stores";
import useAccount from "@/hooks/useAccount";
import { useBalance } from "wagmi";
import { zksyncChainId } from "@/config/config";
import { useTransaction, useWaitForTransaction } from "wagmi";
import { useEffect } from "react";
import store, { actions } from "@/stores";
import useMintType from "@/hooks/useMintType";

const karatStatusMap: any = {
  success: "success",
  loading: "pending",
};

export default function useMintHistory() {
  const mintType = useMintType();
  const historyData = useTypedSelector((state) => {
    return state.mint;
  });

  const history =
    mintType === "validator"
      ? historyData.validatorHistory
      : historyData.claimerHistory;

  const { address } = useAccount();

  const { data: zksyncBalance } = useBalance({
    address: history?.type === "zksync" ? address : undefined,
    chainId: zksyncChainId,
    watch: true,
  });

  const {
    data: karatTrans,
    error,
    status: karatTransStatus,
    isSuccess,
  } = useWaitForTransaction({
    hash: history?.type === "karat" ? (history.transaction as any) : undefined,
    chainId: history?.chainId,
  });

  useEffect(() => {
    if (karatTransStatus === "error") {
      store.dispatch(
        actions.mint.setHistory({
          history: null,
          type: mintType,
        })
      );
    }
  }, [karatTransStatus, mintType]);

  let status = "idle";

  if (history?.type === "zksync") {
    status =
      parseFloat(zksyncBalance?.formatted || "0") >= (history?.value || 0)
        ? "success"
        : "pending";
  } else if (history?.type === "karat") {
    status = karatStatusMap[karatTransStatus] || karatTransStatus;
  }

  return {
    history,
    status,
  };
}
